import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Are your caregivers verified?",
    a: "Yes, all our caregivers undergo thorough police verification, background checks, and identity verification before being onboarded. We also conduct regular training to ensure the highest quality of care.",
  },
  {
    q: "Can I request a replacement caregiver?",
    a: "Replacement will be provided as per availability",
  },
  {
    q: "Is there emergency support available?",
    a: "Yes, we provide 24/7 customer support. In case of any emergency, you can reach us anytime via phone or WhatsApp and our team will respond immediately.",
  },
  {
    q: "How soon can the service start?",
    a: "For most services, we can assign a caregiver within 2-4 hours for urgent requests and within 24 hours for planned care. Emergency requests are prioritized.",
  },
  {
    q: "What are the payment options?",
    a: "We accept UPI, bank transfers, credit/debit cards, and cash payments. Monthly billing is available for long-term care plans with flexible payment schedules.",
  },
  {
    q: "Do you provide services across India?",
    a: "Currently, we operate in major cities including Delhi NCR, Mumbai, Bangalore, Hyderabad, Chennai, Pune, and Kolkata. We're rapidly expanding to more cities.",
  },
  {
    q: "What if my care needs change over time?",
    a: "Our care plans are fully flexible. Your dedicated Relationship Manager will work with you to adjust the care plan as needs evolve — whether it's more hours, additional services, or a different type of care.",
  },
  {
    q: "Are there any hidden charges?",
    a: "No. We believe in complete transparency. The price quoted is the price you pay. Any additional services or changes are discussed and agreed upon before implementation.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-[#14B8A6] uppercase tracking-wider font-body">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#0F172A] tracking-tight mt-3">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-slate-100 rounded-2xl px-6 data-[state=open]:border-[#14B8A6]/20 data-[state=open]:bg-[#F0FDFA] transition-colors"
            >
              <AccordionTrigger className="text-left font-heading text-base font-semibold text-[#0F172A] hover:no-underline py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-[#475569] font-body pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
